import { useEffect, useState } from 'react';
import type { CuttingDraft } from '@pomoshnik/shared';
import { useCuttingStore } from '../state/useCuttingStore';
import { CuttingModal2 } from './CuttingModal2';

/**
 * Block 14 «Раскрой» — модалка «Черновики» (PR #4-SHELL, CUT-1.9).
 * Разметка вербатим `openDraftsDialog` (project.html: `#drafts-modal`,
 * `.drafts-list` / `.draft-item` / `.draft-name` / `.draft-meta`). Данные —
 * `loadDrafts` из стора (PR #3). Выбор → драфт в редактор → переход на «Детали»
 * (как в прототипе `loadDraft` → клик по `.sc-tab[data-tab="details"]`).
 *
 * Пустое состояние — вербатим текст прототипа (P-021 empty).
 */
const EMPTY_TEXT =
  'Черновиков нет. Заполните детали на вкладке «Детали и кромки» и нажмите «Сохранить как черновик».';

export function DraftsDialog({
  onClose,
  onSelect,
}: {
  onClose: () => void;
  onSelect: (draft: CuttingDraft) => void;
}) {
  const drafts = useCuttingStore((s) => s.serverDrafts);
  const loadDrafts = useCuttingStore((s) => s.loadDrafts);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    void loadDrafts().finally(() => {
      if (alive) setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, [loadDrafts]);

  return (
    <CuttingModal2
      title="Черновики"
      footer={
        <button type="button" className="sc-modal-btn" onClick={onClose}>
          Закрыть
        </button>
      }
    >
      <div className="drafts-list">
        {loading ? null : drafts.length === 0 ? (
          <p style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: '20px' }}>
            {EMPTY_TEXT}
          </p>
        ) : (
          drafts.map((d) => (
            <button key={d.id} type="button" className="draft-item" onClick={() => onSelect(d)}>
              <div className="draft-name">{d.name}</div>
              <div className="draft-meta">
                {d.data.parts.length} деталей · {new Date(d.createdAt).toLocaleDateString('ru-RU')}
              </div>
            </button>
          ))
        )}
      </div>
    </CuttingModal2>
  );
}
